const STORAGE_PREFIX = 'lead_param_';

export const LEAD_PARAM_KEYS = [
    'source',
    'sport',
    'package',
    'application_upload_date',
    'site',
    'site_form',
    'site_language',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'ad_id',
    'adset_id',
    'campaign_id',
];

function setSessionCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
}

function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === name) {
            return decodeURIComponent(value);
        }
    }
    return null;
}

export function persistLeadParamsFromLocation(search = window.location.search) {
    if (!search) return;

    const params = new URLSearchParams(search);

    LEAD_PARAM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value !== null) {
            setSessionCookie(`${STORAGE_PREFIX}${key}`, value);
        }
    });
}

function readGaClientId() {
    const raw = getCookie('_ga');
    if (!raw) return null;
    const match = raw.match(/^GA1\.\d+\.(.+)$/);
    return match ? match[1] : null;
}

function readGaSessionId() {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name && name.startsWith('_ga_') && name !== '_ga') {
            const decoded = decodeURIComponent(value || '');
            const match = decoded.match(/^GS1\.\d+\.(\d+)/);
            if (match) return match[1];
        }
    }
    return null;
}

export function loadStoredLeadParams() {
    const result = {};

    LEAD_PARAM_KEYS.forEach((key) => {
        const cookieValue = getCookie(`${STORAGE_PREFIX}${key}`);
        if (cookieValue !== null && cookieValue !== '') {
            result[key] = cookieValue;
        }
    });

    const gaClientId = readGaClientId();
    if (gaClientId) result.ga_client_id = gaClientId;

    const gaSessionId = readGaSessionId();
    if (gaSessionId) result.ga_session_id = gaSessionId;

    return result;
}
